<template>
    <div class="row">
        <div class="col-sm-12 col-md-12">
            <h3 class="mb-0">Create a Buy Group Date</h3>
            <div class="row mt-3">
                <div class="col-md-4 pb-2">
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="pricelist_id">
                                    Pricelist
                                </label>
                                <select
                                    class="form-control"
                                    v-model="form.pricelist_id"
                                    required
                                >
                                    <template
                                        v-for="(item, idx) in pricelistsTable"
                                        :key="idx"
                                    >
                                        <option :value="item.id">
                                            {{ item.pricelist_name }}
                                        </option>
                                    </template>
                                </select>
                                <span
                                    class="text-danger"
                                    v-if="v$.form.pricelist_id.$errors"
                                >
                                    {{ v$.form.pricelist_id.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="category_name"
                                    >Category Name</label
                                >
                                <input
                                    type="text"
                                    name="name"
                                    v-model="form.category_name"
                                    class="form-control"
                                    required
                                    autofocus
                                />
                                
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="name"
                                    >Name</label
                                >
                                <input
                                    type="text"
                                    name="name"
                                    v-model="form.name"
                                    class="form-control"
                                    required
                                    autofocus
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.form.name.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.form.name.$errors"
                                >
                                    {{ v$.form.name.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="require_all_items">
                                    Require All Items
                                </label>
                                <select
                                    class="form-control"
                                    v-model="form.require_all_items"
                                    required
                                >
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                                <span
                                    class="text-danger"
                                    v-if="v$.form.require_all_items.$errors"
                                >
                                    {{ v$.form.require_all_items.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-sm-12 col-md-6">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="is_premier_dealer">
                                    Premier Dealer
                                </label>
                                <select
                                    class="form-control"
                                    v-model="form.is_premier_dealer"
                                    required
                                >
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                                <span
                                    class="text-danger"
                                    v-if="v$.form.is_premier_dealer.$errors"
                                >
                                    {{ v$.form.is_premier_dealer.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="is_buy_group_dealer">
                                    Buy Group Dealer
                                </label>
                                <select
                                    class="form-control"
                                    v-model="form.is_buy_group_dealer"
                                    required
                                >
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                                <span
                                    class="text-danger"
                                    v-if="v$.form.is_buy_group_dealer.$errors"
                                >
                                    {{ v$.form.is_buy_group_dealer.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 pb-2">
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="order_suppressor_minimum_quantity"
                                    >Order Suppressor Minimum Qty</label
                                >
                                <input
                                    type="number"
                                    name="order_suppressor_minimum_quantity"
                                    v-model="form.order_suppressor_minimum_quantity"
                                    class="form-control"
                                    required
                                    autofocus
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.form.order_suppressor_minimum_quantity.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.form.order_suppressor_minimum_quantity.$errors"
                                >
                                    {{ v$.form.order_suppressor_minimum_quantity.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="accessories_minimum_quantity"
                                    >Accessories Minimum Qty</label
                                >
                                <input
                                    type="number"
                                    name="accessories_minimum_quantity"
                                    v-model="form.accessories_minimum_quantity"
                                    class="form-control"
                                    required
                                    autofocus
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.form.accessories_minimum_quantity.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.form.accessories_minimum_quantity.$errors"
                                >
                                    {{ v$.form.accessories_minimum_quantity.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="minimum_quantity_per_item"
                                    >Minimum Qty Per Item</label
                                >
                                <input
                                    type="number"
                                    name="minimum_quantity_per_item"
                                    v-model="form.minimum_quantity_per_item"
                                    class="form-control"
                                    required
                                    autofocus
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.form.minimum_quantity_per_item.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.form.minimum_quantity_per_item.$errors"
                                >
                                    {{ v$.form.minimum_quantity_per_item.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label class="form-control-label text-muted" for="order_minimum"
                                    >Order Minimum</label
                                >
                                <input
                                    type="number"
                                    name="order_minimum"
                                    v-model="form.order_minimum"
                                    class="form-control"
                                    required
                                    autofocus
                                    :class="{
                                        'is-invalid':
                                            submitted && v$.form.order_minimum.$error,
                                    }"
                                />
                                <span
                                    class="text-danger"
                                    v-if="v$.form.order_minimum.$errors"
                                >
                                    {{ v$.form.order_minimum.$errors[0]?.$message }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-sm-12 col-md-6">
                            <div class="form-group">
                                <label class="text-muted">Start Date</label>
                                <datepicker
                                    class="form-control"
                                    v-model="form.start_date"
                                    :lower-limit="lowerLimit"
                                />
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="form-group">
                                <label class="text-muted">End Date</label>
                                <datepicker
                                    class="form-control"
                                    v-model="form.end_date"
                                    :lower-limit="lowerLimit"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row pt-2">
                        <div class="col-sm-12 col-md-6">
                            
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="form-group">
                                <label class="text-muted">Admin End Date</label>
                                <datepicker
                                    class="form-control"
                                    v-model="form.admin_end_date"
                                    :lower-limit="lowerLimit"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="row mt-5 submit-order-button">
                <div class="col-md-4">
                    <button
                        @click="handleSubmit"
                        type="submit"
                        class="btn btn-outline-danger text-uppercase float-end w-100"
                    >
                        Submit 
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import {
    required,
    email,
    minLength,
    sameAs,
    requiredIf,
} from "@vuelidate/validators";

export default {
    props: [],
    emits: [],
    components: {},
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });

        let pricelistsTable = computed(function () {
            return store.state.pricelistsTable;
        });

        onMounted(() => {
            
        });

        return {
            store,
            user,
            pricelistsTable,
        };
    },
    data() {
        return {
            v$: useVuelidate(),
            form: {
                pricelist_id: null,
                category_name: '',
                name: '',
                require_all_items: 0,
                is_premier_dealer: 0,
                is_buy_group_dealer: 0,
                order_suppressor_minimum_quantity: 0,
                accessories_minimum_quantity: 0,
                minimum_quantity_per_item: 0,
                order_minimum: 0,
                start_date: new Date(),
                end_date: new Date(),
                admin_end_date: new Date(),
            },
            lowerLimit: new Date(),
            submitted: false,
            buy_group_dates_users_with_access: JSON.parse(process.env.MIX_BUY_GROUP_DATES_USERS_WITH_ACCESS),
        };
    },
    validations() {
        return {
            form: {
                pricelist_id: { required },
                // category_name: { required },
                name: { required },
                require_all_items: { required },
                is_premier_dealer: { required },
                is_buy_group_dealer: { required },
                order_suppressor_minimum_quantity: { required },
                accessories_minimum_quantity: { required },
                minimum_quantity_per_item: { required },
                order_minimum: { required },
                start_date: { required },
                end_date: { required },
                admin_end_date: { required },
            }
        };
    },
    computed: {
        
    },
    mounted() {
        if (this.buy_group_dates_users_with_access.includes(this.user.id)) {
            this.store.dispatch("getPricelistsTable");
        } else {
            this.$router.push({ name: "dashboard" });
        }
    },
    methods: {
        handleSubmit(e) {
            this.submitted = true;

            this.v$.$validate();
            if (!this.v$.$error) {
                // if ANY fail validation
                this.submitBuyGroupDate();
            } else {
                // alert('Form failed validation')
            }
        },
        submitBuyGroupDate() {

            // SAVE QUOTE
            window.emitter.emit("changeLoaderStatus", true);
            axios.post("/api/submit-buy-group-date", this.form)
                .then((resp) => {
                    window.emitter.emit("changeLoaderStatus", false);

                    this.$router.push({ name: 'Settings', query: {tab: 'buygroup'} });

                    setTimeout(() => {
                        window.emitter.emit("alertSuccess", {
                          message:
                          "Buy Group Date was created successfully!",
                        });
                    }, 2000)
                });
        },
        
    },
};
</script>
